import Alpine from "alpinejs";

Alpine.store("viewport", {
  width: window.innerWidth,
  height: window.innerHeight,
  isTouch: "ontouchstart" in window || navigator.maxTouchPoints > 0,
});

function handleResize() {
  requestAnimationFrame(rafResize);
}

function rafResize() {
  viewport.width = window.innerWidth;
  viewport.height = window.innerHeight;
}

window.addEventListener("resize", handleResize);

interface ViewPort {
  width: number;
  height: number;
  isTouch: boolean;
}

export const viewport = Alpine.store("viewport") as ViewPort;
